import { SectionTypeEnum } from '@vedalib/editor/lib/elements'

import { KeyIconsType } from 'components/uiKit/Icon/Icon'
import { FileUsageContext, SectionOrderSchemaFragment } from 'gql/__generated__/graphql'

export type UsageBlockItem = {
  context?: FileUsageContext | null
  id: string
  usageId: string
  blockName: string
  blockUrl: string
  isCropped: boolean
}

export type UsageSectionItem = {
  id: string
  sectionName: string
  sectionType: SectionTypeEnum
  blocksOrder: string[]
  blocks: UsageBlockItem[]
}

export type FileUsageState = {
  projectName: string
  projectId: string
  sectionsOrder: SectionOrderSchemaFragment[]
  sections: UsageSectionItem[]
}

export enum FlattUsageTypeEnum {
  block = 'block',
  section = 'section',
  project = 'project',
}

export type FlattenUsageState = {
  name: React.ReactNode
  type: FlattUsageTypeEnum
  icon?: KeyIconsType
  blockName?: string
}
